<template lang="pug">
  .row
    form.col-md-3
      .form-group
        label(for='storeNam')
          b Store name
        .d-flex.align-items-center
          span.mr-2 https:// 
          input.form-control(type='text', v-model="storeName").mr-2
          span .myshopify.com
        //- small.form-text.text-muted Your store name
      button.btn.btn-primary(v-on:click.prevent="loginWithShopify()").custom-btn  
        b Login with Shopify
      .error.mt-3 {{error}}
</template>

<script>
import {randomString} from '@/tools.js'
export default {
  name: 'Login',
  props:{},
  data() {
    return {
      storeName: null,
      error: null
    }
  },
  mounted() {
  },
  methods: {
    loginWithShopify(){
      if(!/^[A-Za-z0-9_-]*$/.test(this.storeName)){
        this.error = "Store name can only contain letters, numbers, hyphens or underscores."
        return;
      }
      if(!this.storeName) {
          this.error = "You must type a store name";
          return;
      }
      const scopes = "read_orders,write_orders,read_products,write_products,read_inventory,write_inventory,read_locations,read_customers";
      const redirectUri = process.env.VUE_APP_SHOPIFY_REDIRECT_URI;
      const nonce = randomString(15);
      localStorage.setItem("authenticationNonce", nonce)
      const url = `https://${this.storeName}.myshopify.com/admin/oauth/authorize?client_id=${process.env.VUE_APP_SHOPIFY_API_KEY}&scope=${scopes}&redirect_uri=${redirectUri}&state=${nonce}`;
      window.location.href=url
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  @import url('@/less/global.less');
  .custom-btn, .custom-btn:hover, .custom-btn:active {
    background: @primary;
    border: none;
  }
  .error {
    color: rgb(88, 0, 0);
    font-weight: 600;
    font-size: 14px;
  }
</style>
